import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/auth";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { RecordForm } from "@/pages/admin/ClientRecordsTab";

const EMPTY = {
  profile_type: "professionnel", first_name: "", last_name: "",
  address_line1: "", address_line2: "", postal_code: "", city: "", country: "France",
  billing_email: "", phone: "", company_name: "", trade_name: "",
  siren: "", siret: "", vat_number: "", no_vat: false, contacts: [], internal_note: "",
};

export function EndClientDialog({ open, onOpenChange, initial, onSaved }) {
  const [value, setValue] = useState(EMPTY);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) { setValue(initial ? { ...EMPTY, ...initial } : EMPTY); }
  }, [open, initial]);

  const save = async () => {
    setBusy(true);
    try {
      const payload = { ...value, contacts: [], internal_note: "" };
      const { data } = initial?.id
        ? await api.patch(`/me/end-clients/${initial.id}`, payload)
        : await api.post("/me/end-clients", payload);
      toast.success(initial?.id ? "Client mis à jour" : "Client ajouté");
      onSaved?.(data);
      onOpenChange(false);
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="end-client-dialog">
        <DialogHeader>
          <DialogTitle>{initial?.id ? "Modifier le client final" : "Ajouter un client final"}</DialogTitle>
          <DialogDescription>
            Ces informations servent uniquement si vous choisissez de faire facturer ce client directement.
            Aucun compte n'est créé pour lui et il n'a pas accès à votre espace.
          </DialogDescription>
        </DialogHeader>
        <RecordForm value={value} onChange={setValue} testPrefix="ec" simple />
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" onClick={() => onOpenChange(false)} className="cs-btn-ghost !text-black !border-black" data-testid="ec-cancel"><span>Annuler</span></button>
          <button type="button" onClick={save} disabled={busy} className="cs-btn-primary" data-testid="ec-save">
            {busy && <Loader2 size={14} className="animate-spin" />} Enregistrer
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
